import axios from "axios";
import {
  setDateHoursToMidNight,
  setDateHoursToBeforeMidNight,
  adminApi,
} from "../utils";
import { msalPluginInstance } from "@/plugins/msal-plugin";
import { AppConfig } from "@/app.config";
import store from "@/store";

const apiRequest = async (method, endpoint, payload = null) => {
  try {
    const bearerToken = await accessTokenFn();
    const arenaEnvAPI = await adminApi();
    const url = `${arenaEnvAPI}/${endpoint}`;
    const headers = { Authorization: `Bearer ${bearerToken}` };

    const response = await axios({
      method,
      url,
      headers,
      data: payload,
    });

    return response.data;
  } catch (err) {
    console.error(`API error in ${method.toUpperCase()} ${endpoint}: ${err}`);
    throw err;
  }
};

export const getYellowBannerEventsListAPI = async () => {
  const bearerToken = await accessTokenFn();
  const arenaEnvAPI = await adminApi();
  return new Promise((resolve, reject) => {
    axios
      .get(arenaEnvAPI + "/notification-banner", {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
        },
      })
      .then((response) => {
        resolve(orderEventsByDate(response.data));
      })
      .catch((err) => {
        console.error("err: " + err);
        reject(err);
      });
  });
};
export const postYellowBannerAPI = async (payload) => {
  const bearerToken = await accessTokenFn();
  const arenaEnvAPI = await adminApi();
  return new Promise((resolve, reject) => {
    axios
      .post(arenaEnvAPI + "/notification-banner", payload, {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
        },
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        console.error("API err: " + err);
        reject(err);
      });
  });
};
export const putYellowBannerAPI = async (payload) => {
  const bearerToken = await accessTokenFn();
  const arenaEnvAPI = await adminApi();
  return new Promise((resolve, reject) => {
    axios
      .put(arenaEnvAPI + "/notification-banner/" + payload.eventKey, payload, {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
        },
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        console.error("err: " + err);
        reject(err);
      });
  });
};
export const deleteYellowBannerAPI = async (payload) => {
  const bearerToken = await accessTokenFn();
  const arenaEnvAPI = await adminApi();
  return new Promise((resolve, reject) => {
    axios
      .delete(arenaEnvAPI + "/notification-banner/" + payload, {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
        },
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        console.error("err: " + err);
        reject(err);
      });
  });
};

export const getPromoBannerAPI = async () => {
  const bearerToken = await accessTokenFn();
  const arenaEnvAPI = await adminApi();
  return new Promise((resolve, reject) => {
    axios
      .get(arenaEnvAPI + "/promo-event", {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
        },
      })
      .then((response) => {
        resolve(orderEventsByDate(response.data));
      })
      .catch((err) => {
        console.error("err: " + err);
        reject(err);
      });
  });
};
export const postPromoBannerAPI = async (payload) => {
  const bearerToken = await accessTokenFn();
  const arenaEnvAPI = await adminApi();
  return new Promise((resolve, reject) => {
    axios
      .post(arenaEnvAPI + "/promo-event", payload, {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
        },
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        console.error("API err: " + err);
        reject(err);
      });
  });
};
export const putPromoBannerAPI = async (payload) => {
  const bearerToken = await accessTokenFn();
  const arenaEnvAPI = await adminApi();
  return new Promise((resolve, reject) => {
    axios
      .put(arenaEnvAPI + "/promo-event/" + payload.eventKey, payload, {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
        },
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        console.error("err: " + err);
        reject(err);
      });
  });
};
export const deletePromoAPI = async (payload) => {
  const bearerToken = await accessTokenFn();
  const arenaEnvAPI = await adminApi();
  return new Promise((resolve, reject) => {
    axios
      .delete(arenaEnvAPI + "/promo-event/" + payload, {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
        },
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        console.error("err: " + err);
        reject(err);
      });
  });
};

export const getGamesSeoAPI = async () => {
  const bearerToken = await accessTokenFn();
  const arenaEnvAPI = await adminApi();
  return new Promise((resolve, reject) => {
    axios
      .get(arenaEnvAPI + "/games-seo", {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
        },
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        console.error("err: " + err);
        reject(err);
      });
  });
};
export const postGamesSeoAPI = async (payload) => {
  const bearerToken = await accessTokenFn();
  const arenaEnvAPI = await adminApi();
  return new Promise((resolve, reject) => {
    axios
      .post(arenaEnvAPI + "/games-seo", payload, {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
        },
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        console.error("API err: " + err);
        reject(err);
      });
  });
};
export const putGamesSeoAPI = async (payload) => {
  const bearerToken = await accessTokenFn();
  const arenaEnvAPI = await adminApi();
  return new Promise((resolve, reject) => {
    axios
      .put(arenaEnvAPI + "/games-seo/" + payload.Key, payload, {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
        },
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        console.error("err: " + err);
        reject(err);
      });
  });
};
export const deleteGameSeoAPI = async (payload) => {
  const bearerToken = await accessTokenFn();
  const arenaEnvAPI = await adminApi();
  return new Promise((resolve, reject) => {
    axios
      .delete(arenaEnvAPI + "/games-seo/" + payload, {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
        },
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        console.error("err: " + err);
        reject(err);
      });
  });
};

export const getImagesListAPI = async () => {
  const bearerToken = await accessTokenFn();
  const arenaEnvAPI = await adminApi();
  return new Promise((resolve, reject) => {
    axios
      .get(arenaEnvAPI + "/image", {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
        },
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        console.error("err: " + err);
        reject(err);
      });
  });
};
export const deleteImageAPI = async (payload) => {
  const bearerToken = await accessTokenFn();
  const arenaEnvAPI = await adminApi();
  return new Promise((resolve, reject) => {
    axios
      .delete(arenaEnvAPI + "/image/" + payload, {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
        },
      })
      .then((response) => {
        resolve(response);
      })
      .catch((err) => {
        console.error("err: " + err);
        reject(err);
      });
  });
};

export const getGamesFeedAPI = async () => {
  const baseURL = AppConfig.gamesApiUrl;
  const arenaEnv = store.getters["selectEnv/getEnv"];
  let feedId = AppConfig.gamesFeedIdStage;
  if (AppConfig.currentAdminEnv === "production" || arenaEnv === "prod") {
    feedId = AppConfig.gamesFeedIdProd;
  }

  return axios.get(`${baseURL}feeds/${feedId}/games/?locale=en`);
};

export const getOldGamesFeedAPI = () => {
  const baseURL = AppConfig.aarpBlob;
  const arenaEnv = store.getters["selectEnv/getEnv"];
  let axiosURL = "";
  if (AppConfig.currentAdminEnv === "development" || arenaEnv === "stage") {
    axiosURL = baseURL + "arenax-game-feeds-content/AARP Staging_en.json";
  } else {
    axiosURL = baseURL + "arenax-game-feeds-content/AARP_en.json";
  }

  return new Promise((resolve) => {
    const res = axios.get(axiosURL);
    resolve(res);
  });
};

export const setClearCacheAPI = () => {
  const mockCodes = [
    { statusCode: 200, message: "OK" },
    { statusCode: 201, message: "Created" },
    { statusCode: 202, message: "Accepted" },
    { statusCode: 203, message: "Non-Authoritative Information" },
    { statusCode: 204, message: "No Content" },
    { statusCode: 400, message: "Bad Request" },
    { statusCode: 401, message: "Unauthorized" },
    { statusCode: 403, message: "Forbidden" },
    { statusCode: 404, message: "Not Found" },
    { statusCode: 405, message: "Method Not Allowed" },
    { statusCode: 408, message: "Request Timeout" },
    { statusCode: 500, message: "Internal Server Error" },
    { statusCode: 502, message: "Bad Gateway" },
    { statusCode: 503, message: "Service Unavailable" },
  ];
  return new Promise((resolve) => {
    let rndCode = mockCodes[Math.floor(Math.random() * mockCodes.length)];
    setTimeout(() => {
      resolve(rndCode);
    }, 1500);
  });
};

const accessTokenFn = async () => {
  const $msal = msalPluginInstance;
  const token = await $msal.acquireToken();
  return token;
};

const orderEventsByDate = async (event) => {
  const sortedEventsList = event
    .slice()
    .sort(
      (a, b) =>
        new Date(b.eventDateStart) -
        new Date(a.eventDateStart)
    );
  await setEventStats(sortedEventsList);
  return sortedEventsList;
};

const setEventStats = async (eventList) => {
  const today = new Date();
  return eventList.map((e) => {
    const startDate = setDateHoursToMidNight(e.eventDateStart);
    const endDate = setDateHoursToBeforeMidNight(e.eventDateEnd);
    if (today > endDate) {
      e.stats = "closed";
      e.timeLineColor = "red";
    } else if (today < startDate) {
      e.stats = "waiting";
      e.timeLineColor = "yellow";
    } else {
      e.stats = "active";
      e.timeLineColor = "green";
    }
  });
};

export const getEngagementPromoAPI = async () => {
  const bearerToken = await accessTokenFn();
  const arenaEnvAPI = await adminApi();
  return new Promise((resolve, reject) => {
    axios
      .get(arenaEnvAPI + "/engagement-promos", {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
        },
      })
      .then((response) => {
        resolve(orderEventsByDate(response.data));
      })
      .catch((err) => {
        console.error("err: " + err);
        reject(err);
      });
  });
};
export const postEngagementPromoAPI = async (payload) => {
  const bearerToken = await accessTokenFn();
  const arenaEnvAPI = await adminApi();
  return new Promise((resolve, reject) => {
    axios
      .post(arenaEnvAPI + "/engagement-promos", payload, {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
        },
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        console.error("API err: " + err);
        reject(err);
      });
  });
};
export const putEngagementPromoAPI = async (payload) => {
  const bearerToken = await accessTokenFn();
  const arenaEnvAPI = await adminApi();
  return new Promise((resolve, reject) => {
    axios
      .put(arenaEnvAPI + "/engagement-promos/" + payload.eventKey, payload, {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
        },
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        console.error("err: " + err);
        reject(err);
      });
  });
};
export const deleteEngagementPromoAPI = async (payload) => {
  const bearerToken = await accessTokenFn();
  const arenaEnvAPI = await adminApi();
  return new Promise((resolve, reject) => {
    axios
      .delete(arenaEnvAPI + "/engagement-promos/" + payload, {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
        },
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        console.error("err: " + err);
        reject(err);
      });
  });
};

export const getCrossPromotionAPI = async () => {
  const bearerToken = await accessTokenFn();
  const arenaEnvAPI = await adminApi();
  return new Promise((resolve, reject) => {
    axios
      .get(arenaEnvAPI + "/cross-promotions", {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
        },
      })
      .then((response) => {
        resolve(orderEventsByDate(response.data));
      })
      .catch((err) => {
        console.error("err: " + err);
        reject(err);
      });
  });
};
export const postCrossPromotionAPI = async (payload) => {
  const bearerToken = await accessTokenFn();
  const arenaEnvAPI = await adminApi();
  return new Promise((resolve, reject) => {
    axios
      .post(arenaEnvAPI + "/cross-promotions", payload, {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
        },
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        console.error("API err: " + err);
        reject(err);
      });
  });
};
export const putCrossPromotionAPI = async (payload) => {
  const bearerToken = await accessTokenFn();
  const arenaEnvAPI = await adminApi();
  return new Promise((resolve, reject) => {
    axios
      .put(arenaEnvAPI + "/cross-promotions/" + payload.eventKey, payload, {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
        },
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        console.error("err: " + err);
        reject(err);
      });
  });
};
export const deleteCrossPromotionAPI = async (payload) => {
  const bearerToken = await accessTokenFn();
  const arenaEnvAPI = await adminApi();
  return new Promise((resolve, reject) => {
    axios
      .delete(arenaEnvAPI + "/cross-promotions/" + payload, {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
        },
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        console.error("err: " + err);
        reject(err);
      });
  });
};

export const getPreviewModeAPI = async () =>
  apiRequest("GET", "preview-mode").then(orderEventsByDate);

export const postPreviewModeAPI = async (payload) =>
  apiRequest("POST", "preview-mode", payload);

export const putPreviewModeAPI = async (payload) =>
  apiRequest("PUT", `preview-mode/${payload.eventKey}`, payload);

export const deletePreviewModeAPI = async (payload) =>
  apiRequest("DELETE", `preview-mode/${payload}`);
